<template>
    <v-card>
        <v-card-text class="black--text pt-0">
            <div class="title font-weight-bold pb-4">
                {{ $t('ticketAndAddOns.ticketHeader') }}
            </div>

            <product-table
                :excludeHeaders="[
                    'TicketNumber',
                    'total',
                    'amount'
                ]"
                :items="tickets"
                :options="ticketPagination"
                @viewDetails="viewTicketDetails"/>

            <div class="title font-weight-bold py-4">
                {{ $t('ticketAndAddOns.addOnHeader') }}
            </div>

            <product-table
                :excludeHeaders="[
                    'TicketNumber',
                    'total',
                    'amount'
                ]"
                :items="addOns"
                :options="addOnPagination"
                @viewDetails="viewAddOnDetails"/>

            <div class="title font-weight-bold py-4">
                {{ $t('ticketAndAddOns.kabanaHeader') }}
            </div>

            <product-table
                :excludeHeaders="[
                    'TicketNumber',
                    'total',
                    'amount'
                ]"
                :items="kabanas"
                :options="kabanaPagination"
                @viewDetails="viewKabanaDetails"/>
        </v-card-text>

        <right-panel
            ref="productDetailsPanel"
            :title="$t('ticketAndAddOns.productDetails.header')">
            <template v-slot:content="{ context }" >
                <product-details-view
                    :product="context"/>
            </template>

            <template v-slot:bottom>
                <v-spacer/>
                <button-status-field
                    :status="$constant.ACTIVE_STATUS"/>
                <button-status-field
                    class="ml-0"
                    :status="$constant.INACTIVE_STATUS"/>
            </template>
        </right-panel>
    </v-card>
</template>

<script>
import RightPanel from '@/components/panels/RightPanel'
import ProductDetailsView from '@/views/ProductDetailsView'
import ButtonStatusField from '@/components/fields/ButtonStatusField'
import ProductTable from '@/components/tables/ProductTable'

import { mapGetters } from 'vuex'

export default {
    name: 'ProductListView',

    components: {
        RightPanel,
        ProductDetailsView,
        ButtonStatusField,
        ProductTable
    },

    props: {
        tickets: {
            type: Array,
            default: () => []
        },

        ticketPagination: {
            type: Object,
            default: () => ({})
        },

        addOns: {
            type: Array,
            default: () => []
        },

        addOnPagination: {
            type: Object,
            default: () => ({})
        },

        kabanas: {
            type: Array,
            default: () => []
        },

        kabanaPagination: {
            type: Object,
            default: () => ({})
        }
    },

    computed: {
        ...mapGetters({
            getTicketById: 'product/getTicketById',
            getAddOnById: 'product/getAddOnById',
            getKabanaById: 'product/getKabanaById'
        })
    },

    methods: {
        viewTicketDetails (ticketItem) {
            const ticket = this.getTicketById(ticketItem.id)

            if (ticket) {
                this.$refs.productDetailsPanel.open(ticket)
            }
        },

        viewAddOnDetails (addOnsItem) {
            const addOn = this.getAddOnById(addOnsItem.id)

            if (addOn) {
                this.$refs.productDetailsPanel.open(addOn)
            }
        },

        viewKabanaDetails (kabanaItem) {
            const kabana = this.getKabanaById(kabanaItem.id)

            if (kabana) {
                this.$refs.productDetailsPanel.open(kabana)
            }
        }
    }
}
</script>

<style lang="scss" scoped></style>
